module.exports = __webpack_public_path__ + "img/job-list.355cb995.png";